import { ContentTag, provideComponent } from "scrivito"
import { PortalNewsPostObjClass } from "scrivito/Objs/PortalNewsPost/PortalNewsPostObjClass"
import { useScrivitoPage } from "scrivito/hooks/useScrivitoPage"
import { ScrivitoPageBreadcrumb } from "scrivito/scrivito-breadcrumb/ScrivitoPageBreadcrumb"

import { useScrollController } from "features/scroll-management/model/useScrollController"
import { ScrivitoPortalNewsListItem } from "widgets/portal-news-list/ui/ScrivitoPortalNewsListItem"

import "./styles/_portal-news-post-page.scss"

provideComponent(PortalNewsPostObjClass, ({ page }) => {
  useScrivitoPage()
  useScrollController()

  return (
    <div className="page portal-news-post-page">
      <ScrivitoPageBreadcrumb page={page} />
      <ContentTag tag="h1" content={page.parent()} attribute="title" />
      <ScrivitoPortalNewsListItem key={page.id()} post={page} />
    </div>
  )
})
